import { fontSizes } from '../../../../constants/constants';
import dynamicfunction from '../../../../utils/dynamicfunction';
import { ErrorText, RadioButton, RowView, Text } from '../index';
const PassiveNonFinancialEntity = ({
  getContent,
  values,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  touched,
  optionsYesOrNO,
  errors,
}) => {
  const { TextWeight } = dynamicfunction();
  return (
    <>
      <div className='pt-3 sm:pt-5'>
        <Text
          text={getContent('if_passive_non_Financial_entity')}
          size={fontSizes.h18}
          isTruncate={false}
          weight={TextWeight.medium}
          className='block'
          isRequired={true}
        />
      </div>
      <RowView className='w-full pt-3 sm:pt-5'>
        <RadioButton
          label={getContent('are_you_passive_nfe')}
          value={values?.passiveNfe}
          onChange={(e) => {
            setFieldValue('passiveNfe', e);
            setFieldTouched('passiveNfe', false);
          }}
          options={optionsYesOrNO}
          required={false}
        />
        <ErrorText text={getContent(touched?.passiveNfe ? errors?.passiveNfe : '')} />
      </RowView>
    </>
  );
};
export default PassiveNonFinancialEntity;
